export const type = 'embed';
export const isEmbed = node => node.type === type;
